"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildSharedEventProperties = buildSharedEventProperties;
exports.buildWebPosthogEventProperties = buildWebPosthogEventProperties;
exports.isFrontendOnlyEvent = isFrontendOnlyEvent;
var _internal = require("./_internal");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function resolveCountryCode(user) {
  return user && user.countryCode || user && user.country_code;
}
function resolveIsMember(user) {
  if (user && user.isMember !== undefined) {
    return user.isMember;
  }
  return user && user.is_member;
}
function userGroupForSite(user, site) {
  if (typeof (user === null || user === void 0 ? void 0 : user.userGroupForSite) === 'function') {
    return user.userGroupForSite(site);
  }
  if (!user || !site || !Array.isArray(user.userGroups)) {
    return null;
  }
  return user.userGroups.find(function (item) {
    return item && item.group && item.group.siteId === site.id;
  });
}
function resolveMembershipTypeId(user, site) {
  if (site && !site.isSeedlang) {
    var _userGroupForSite;
    return (_userGroupForSite = userGroupForSite(user, site)) === null || _userGroupForSite === void 0 ? void 0 : _userGroupForSite.membershipTypeId;
  }
  if (user && user.membershipTypeId !== undefined) {
    return user.membershipTypeId;
  }
  return user && user.membership_type_id;
}
function resolveSiteName(site) {
  return site && site.teamName || site && site.team_name || site && site.name;
}
function isFrontendOnlyEvent(eventType) {
  return typeof eventType === 'string' && eventType.startsWith('memrev - ');
}
function buildSharedEventProperties(_ref) {
  var _ref$params = _ref.params,
    params = _ref$params === void 0 ? {} : _ref$params,
    user = _ref.user,
    site = _ref.site;
  return (0, _internal.compactObject)(_objectSpread(_objectSpread({}, params), {}, {
    is_member: params.is_member !== undefined ? params.is_member : resolveIsMember(user),
    membership_type_id: params.membership_type_id !== undefined ? params.membership_type_id : resolveMembershipTypeId(user, site),
    site_id: params.site_id !== undefined ? params.site_id : site && site.id,
    site_name: params.site_name !== undefined ? params.site_name : resolveSiteName(site),
    country_code: params.country_code !== undefined ? params.country_code : resolveCountryCode(user)
  }));
}
function buildWebPosthogEventProperties(_ref2) {
  var eventType = _ref2.eventType,
    _ref2$params = _ref2.params,
    params = _ref2$params === void 0 ? {} : _ref2$params,
    user = _ref2.user,
    site = _ref2.site;
  var baseParams = buildSharedEventProperties({
    params: params,
    user: user,
    site: site
  });
  if (isFrontendOnlyEvent(eventType)) {
    return baseParams;
  }
  return _objectSpread(_objectSpread({}, baseParams), {}, {
    platform: 'web'
  });
}